var _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "btn/edit"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7176 19.2222L12.9808 18.8873C13.0739 18.8625 13.159 18.8127 13.2257 18.7435L24.6987 6.83453C24.9013 6.62454 24.895 6.28971 24.685 6.08765L23.7096 5.14769C23.4996 4.9451 23.1653 4.95145 22.9627 5.16144L11.4896 17.0704C11.4225 17.1402 11.3759 17.2264 11.3548 17.3206L11.067 18.5953C10.9797 18.9825 11.3341 19.3237 11.7176 19.2222ZM16.9529 7.58755C16.9529 7.05265 16.5193 6.61902 15.9844 6.61902H6.99743L6.87939 6.6222C5.74613 6.68348 4.84668 7.62177 4.84668 8.7703V21.8969L4.84986 22.0149C4.91111 23.1478 5.84898 24.0476 6.99743 24.0476H20.124L20.242 24.0445C21.3748 23.9832 22.2748 23.0449 22.2748 21.8969V14.6301L22.2703 14.5368C22.2234 14.0457 21.8097 13.6615 21.3062 13.6615C20.7713 13.6615 20.3377 14.0952 20.3377 14.6301V21.8969L20.3333 21.9399C20.3134 22.0372 20.2271 22.1106 20.124 22.1106H6.99743L6.95434 22.1062C6.85693 22.0863 6.78375 22.0002 6.78375 21.8969V8.7703L6.78809 8.72705C6.808 8.6293 6.89408 8.55609 6.99743 8.55609H15.9844L16.0777 8.55166C16.5688 8.50473 16.9529 8.091 16.9529 7.58755Z",
    fill: "#E37B3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4885",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7176 19.2222L12.9808 18.8873C13.0739 18.8625 13.159 18.8127 13.2257 18.7435L24.6987 6.83453C24.9013 6.62454 24.895 6.28971 24.685 6.08765L23.7096 5.14769C23.4996 4.9451 23.1653 4.95145 22.9627 5.16144L11.4896 17.0704C11.4225 17.1402 11.3759 17.2264 11.3548 17.3206L11.067 18.5953C10.9797 18.9825 11.3341 19.3237 11.7176 19.2222ZM16.9529 7.58755C16.9529 7.05265 16.5193 6.61902 15.9844 6.61902H6.99743L6.87939 6.6222C5.74613 6.68348 4.84668 7.62177 4.84668 8.7703V21.8969L4.84986 22.0149C4.91111 23.1478 5.84898 24.0476 6.99743 24.0476H20.124L20.242 24.0445C21.3748 23.9832 22.2748 23.0449 22.2748 21.8969V14.6301L22.2703 14.5368C22.2234 14.0457 21.8097 13.6615 21.3062 13.6615C20.7713 13.6615 20.3377 14.0952 20.3377 14.6301V21.8969L20.3333 21.9399C20.3134 22.0372 20.2271 22.1106 20.124 22.1106H6.99743L6.95434 22.1062C6.85693 22.0863 6.78375 22.0002 6.78375 21.8969V8.7703L6.78809 8.72705C6.808 8.6293 6.89408 8.55609 6.99743 8.55609H15.9844L16.0777 8.55166C16.5688 8.50473 16.9529 8.091 16.9529 7.58755Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 30,
    height: 30,
    fill: "#E37B3C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b9203d376ffd2bb9911ce6550ef88d3f.svg";
export { ForwardRef as ReactComponent };